import React from 'react';
import { twMerge } from '@/utils';

interface TableCellProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
  children?: React.ReactNode;
  className?: string;
  /** Is this a header cell? */
  header?: boolean;
}

const TableCell = ({
  children,
  className = '',
  header = false,
  ...props
}: TableCellProps) => {
  const baseClasses = twMerge(
    'tw-px-4 tw-py-3',
    header && 'tw-font-semibold tw-text-gray-700',
    className,
  );

  const Component = header ? 'th' : 'td';

  return (
    <Component className={baseClasses} {...props}>
      {children}
    </Component>
  );
};

export default TableCell;
